import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-select-payment-method',
  templateUrl: './select-payment-method.component.html',
  styleUrls: ['./select-payment-method.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule
  ]
})
export class SelectPaymentMethodComponent implements OnInit, OnDestroy {

  @Output() paymentMethodEvent = new EventEmitter<boolean>();
  paymentForm: UntypedFormGroup;

  private subscription: Subscription;

  constructor(fb: UntypedFormBuilder) {
    this.paymentForm = fb.group({
      paymentControl: fb.control(false, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.subscription = this.paymentForm.controls.paymentControl.valueChanges.subscribe(next => this.paymentMethodEvent.emit(next));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get purchaseOrder() {
    return this.paymentForm.controls.paymentControl.value;
  }

  @Input()
  set purchaseOrder(b: boolean) {
    this.paymentForm.controls.paymentControl.setValue(b);
  }

}
